import React, {useContext, useMemo} from 'react';
import {Tabs} from "antd";
import {PlayerContext} from "../../../shared/contexts/playerContext";
import {AuthContext} from "../../../shared/contexts/authContext";
import {useItemKrTextData} from "../../probability/useItemData";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import {getDiceRewardLogColumns, getDiceRollLogColumns} from "../../logs/columns/diceRaceLogColumns";

const makeSearchParams = (pid, logType) => ({
    begin: dayjs().subtract(3, 'month').startOf('day').unix(),
    end: dayjs().endOf('day').unix(),
    pid,
    logType,
    isUnix: true
});

const PlayerDiceRaceLog = () => {
    const { playerData } = useContext(PlayerContext);
    const { currentUser } = useContext(AuthContext);
    const { data: krItemTextData, isLoading, error } = useItemKrTextData();
    const pid = playerData.pid;

    const rollParams = useMemo(() => makeSearchParams(pid, 'RQDiceRollLog'), [pid]);
    const rewardParams = useMemo(() => makeSearchParams(pid, 'RQDiceRewardLog'), [pid]);
    const rollColumns = useMemo(() => getDiceRollLogColumns(), []);
    const rewardColumns = useMemo(() => getDiceRewardLogColumns(krItemTextData, currentUser), [krItemTextData, currentUser]);

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;

    const items = [
        {
            key: 'roll',
            label: '주사위 굴림',
            children: <LogTemplate columns={rollColumns} defaultSearchParams={rollParams}
                                   routerUrl={'/logs/operation'} logName={'DiceRollLog'} log={'operation'}/>,
        },
        {
            key: 'reward',
            label: '타일 보상',
            children: <LogTemplate columns={rewardColumns} defaultSearchParams={rewardParams}
                                   routerUrl={'/logs/operation'} logName={'DiceRewardLog'} log={'operation'}/>,
        },
    ];

    return <Tabs items={items}/>;
};

export default PlayerDiceRaceLog;
